import React from 'react';

import { Screen } from '@confluence/screen';
import { LoadablePaint } from '@confluence/loadable';

const MobileAppTakeoverPageLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-confluencemobile-webentry-pointsMobileAppTakeoverPage" */ '@confluence/mobile-web/entry-points/MobileAppTakeoverPage'
			)
		).MobileAppTakeoverPage,
});

export const MobileTakeoverPageRoute = () => {
	return (
		<Screen
			screenEvent={{
				name: 'mobileTakeoverPage',
			}}
		>
			<MobileAppTakeoverPageLoader />
		</Screen>
	);
};
